<template>
  <div class="p-create-success g-f-c">
    <div>
      <img src="../../images/publish_success.png" alt="" />
      <p class="mt-16">创建成功~</p>
      <p class="mt-16 subtitle">
        学生可以登录学生中心后查看练习内容
        老师可以在「练习中心」中查看学生练习结果
      </p>
      <footer class="mt-40">
        <button class="go-back" @click="onBackClick">
          <span>返回练习中心 {{ countdown }}</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublishSuccess',
  data() {
    return {
      timerId: null,
      countdown: 5,
    };
  },
  methods: {
    onBackClick() {
      this.$router.replace({
        path: '/pt/exercise-center',
      });
    },
    start() {
      this.timerId = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown === 0) {
          this.onBackClick();
        }
      }, 1000);
    },
    reset() {
      clearInterval(this.timerId);
      this.countdown = 5;
    },
  },
  activated() {
    this.start();
  },
  deactivated() {
    this.reset();
  },
};
</script>

<style lang="scss" scoped>
.p-create-success {
  padding: 32px 32px 100px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
  color: rgba(0, 0, 0, 0.6);
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  img {
    display: block;
    width: 233px;
    margin: 0 auto;
  }
  .subtitle {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
  }
  .go-back {
    width: 170px;
    height: 40px;
    background: #e6f1fc;
    border-radius: 4px;
    border: 1px solid #a3d0fd;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1989fa;
    span {
      display: inline-block;
      background:url("../../images/go_back_2x.png") no-repeat left center;
      background-size: 15px 11px;
      box-sizing: border-box;
      padding-left: 18px;
      text-align: center;
    }
  }
}
</style>
